import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const putChatOnHoldService = async (chatId: string): Promise<AxiosResponse> =>
  AxiosInstance.post('livechat/room.onHold', {
    roomId: chatId,
  });
